import { ComponentsOverrides } from "@mui/material";

interface muiCssBaselineProps {
  styleOverrides: ComponentsOverrides["MuiCssBaseline"];
}

export const muiCssBaseline = (): muiCssBaselineProps => ({
  styleOverrides: {
    "body, html, #root": {
      height: "100%",
    },
    "*": {
      margin: 0,
      padding: 0,
    },
    a: {
      textDecoration: "none",
    },
  },
});
